import React from "react";
import { FormSectionElements, FormSections, LOVValues, SubItem } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { DialogforRadioOptions } from "./DialogforRadioOptions";
interface Props {
    formSection: FormSections;
    ele: FormSectionElements;
    isEng: boolean;
    callback;
}
interface State {
    pickedFieldOptions;
    confirmVisible: boolean;
    deleteIndex: number;
    dialogVisibleForRadioOptions: boolean[];

}


export class GroupDropdownDesignComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
            confirmVisible: false,
            deleteIndex: -1,
            dialogVisibleForRadioOptions: []
        };

        // this.itemList= [{
        //     label: 'Germany', code: 'DE',
        //     items: [
        //         { label: 'Berlin', value: 'Berlin' },
        //         { label: 'Frankfurt', value: 'Frankfurt' },
        //         { label: 'Hamburg', value: 'Hamburg' },
        //         { label: 'Munich', value: 'Munich' }
        //     ]
        // },
        // {
        //     label: 'USA', code: 'US',
        //     items: [
        //         { label: 'Chicago', value: 'Chicago' },
        //         { label: 'Los Angeles', value: 'Los Angeles' },
        //         { label: 'New York', value: 'New York' },
        //         { label: 'San Francisco', value: 'San Francisco' }
        //     ]
        // }]
    }

    dropdownHtml = () => {
        let p = this.props.ele;

        let htmlString = [];
        if (p.ListOfLOVValues == null) {
            p.ListOfLOVValues = [];
        }
        if (p.ListOfLOVValues.length == 0) {
            let lov = new LOVValues();
            lov.parent=p;
            lov.Sequence = 1;
            lov.subItems = [];
            p.ListOfLOVValues.push(lov);
        }

        p.ListOfLOVValues.forEach((x) => {
            htmlString.push(
                <div style={{ display: 'flex' }}>
                    <div style={{ display: 'flex',marginTop: '2px' }}>
                        <div>
                            <InputText placeholder="Please enter group name" value={this.props.isEng ? x.code : x.FRA}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    x.code = e.target.value;
                                }
                                else {
                                    x.FRA = e.target.value;
                                }
                                x.subItems = [];
                                this.props.callback();
                            }}></InputText>     
                        </div>
                                           
                        <div>
                            {this.addSubItem(x)}
                        </div>
                    </div>
                    <div style={{ display: x.code || x.FRA ? 'block' : 'none' }} key={"addoption_" + p.Id}>
                        {/* @ts-ignore */}
                        <Button
                            className="p-button-rounded p-button-secondary"
                            style={{
                                cursor: "pointer",
                                margin: "5px",
                                fontSize: "90%",
                                border: "1px solid #64748B",
                                color: "#64748B",
                                background: "white"
                            }}
                            onClick={() => {
                                if (x.subItems == null) {
                                    x.subItems = [];
                                }
                                let subItem = new SubItem();
                                x.subItems.push(subItem);
                                this.props.callback();
                            }}>
                            Add sub item
                        </Button>
                    </div>
                </div>

            )
        }
        );

        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        let newLov = new LOVValues();
                        newLov.Sequence = p.ListOfLOVValues.length;
                        newLov.subItems=[];
                        newLov.parent=p;
                        p.ListOfLOVValues.push(newLov);
                        this.props.callback();
                    }}>
                    Add group
                </Button>
            </div>
        );

        return htmlString;
    };

    addSubItem=(x)=>{
        let htmlString=[];
        x?.subItems.forEach(subItem => {
            htmlString.push(<div>
                <InputText value={this.props.isEng ? subItem.code : subItem.FRA} onChange={(e) => {
                    if (this.props.isEng) {
                        subItem.code = e.target.value;
                    }
                    else {
                        subItem.FRA = e.target.value;
                    }
                    this.props.callback();
                }}></InputText>
            </div>);
        });

        return htmlString;
    }
    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.ele;
        p.ListOfLOVValues.splice(deleteIndex, 1);
        this.props.callback();
        this.setState({ confirmVisible: false });
    };

    render() {
        return (
            <div>
                {this.dropdownHtml()}
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={this.confirmRemove}
                    reject={() => this.setState({ confirmVisible: false })}
                    closable={false}
                />
            </div>
        );
    }
}
